let store = require("../store");
let actions = require("../actions");

let Pulse = mc.widgets.Pulse;

class TermsAndConditionsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: null,
      disabled: false,
      user: store.getState().user
    };
  }

  componentDidMount() {
    mc.ajax.get("./legal/index.html").then((function (response) {
      this.setState({
        content: response
      });
    }).bind(this));
  }

  acceptTerms() {
    this.setState({
      disabled: true
    });

    actions.acceptTerms(mc.utils.clone(this.state.user.user), "UPDATE");
  }

  rejectTerms() {
    this.setState({
      disabled: true
    });

    actions.logout();
  }

  render() {
    let markup = () => ({ __html: this.state.content });

    if (!this.state.content) {
      return <Pulse margin={150}/>;
    }

    return (
      <div className="rc-terms-and-conditions-view">
        <div className="rc-terms-and-conditions-view-head">
          <img src="./img/rc/wait.svg" width="90" height="82"/>
          <div>{tx("review_policy")}</div>
        </div>
        <div className="mc-legal-view" dangerouslySetInnerHTML={markup()}/>
        <div className="rc-terms-and-conditions-view-buttons">
          <button className="mc-button" disabled={this.state.disabled} onClick={this.rejectTerms.bind(this)}>
            {tx("reject")}
          </button>
          <button className="mc-button" disabled={this.state.disabled} onClick={this.acceptTerms.bind(this)}>
            {tx("accept")}
          </button>
        </div>
      </div>
    );
  }
}

module.exports = TermsAndConditionsView;